"use client";

import { useState, useEffect, useRef } from "react";
import {
  Button,
  Tag,
  Input,
  Space,
  Typography,
  Grid,
  Divider,
  message,
  Popover,
  List
} from "antd";

import {
  EditOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  PlusOutlined,
  SolutionOutlined,
  ScissorOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  CloseOutlined,
  MedicineBoxOutlined,
  HistoryOutlined,
  CheckOutlined
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { addsymptom, getsymptom } from "../../services/doctor/symptom/symptom";
import {
  addFinding,
  getFindings,
} from "../../services/doctor/findings/findings";
import {
  addDiagnoses,
  getDiagnoses,
} from "../../services/doctor/diagnoses/diagnoses";
import {
  addmedicine,
  getmedicine,
} from "../../services/doctor/medicine/medicine";
import {
  addInvestigation,
  getInvestigations,
} from "../../services/doctor/investigation/investigation";
import {
  addInstruction,
  getInstruction,
} from "../../services/doctor/instruction/instruction";
import {
  addProcedure,
  getProcedure,
} from "../../services/doctor/procedure/procedure";
import { useAuth } from "../../services/authentication_API/authService";
import AddModal from "../doctorSettings/AddModal";
import MedicineForm from "../doctorSettings/MedicineForm";
import MedicineModal from "../doctorSettings/MedicineFormForConsultant";
import dayjs from "dayjs";
import { Badge } from "react-bootstrap";
import { addInvestigationGroups, getInvestigationGroup } from "../../services/doctor/investigation_group/ivestigation_group";

const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

const sectionIcons = {
  symptoms: { icon: <FileSearchOutlined />, color: "#ff4d4f" },
  findings: { icon: <SearchOutlined />, color: "#faad14" },
  diagnosis: { icon: <SolutionOutlined />, color: "#1890ff" },
  medicines: { icon: <MedicineBoxOutlined />, color: "#52c41a" },
  investigations: { icon: <FileTextOutlined />, color: "#13c2c2" },
  instructions: { icon: <EditOutlined />, color: "#722ed1" },
  procedures: { icon: <ScissorOutlined />, color: "#eb2f96" },
};

export default function SectionManager({
  activeSection1,
  iteam,
  sections,
  onItemSelect,
  addInvestigationPanel,
  onIteamRemove,
  autoSave,
  refresh,
  setShowSidebar,
  setSearchQuery1,
  caseSheetData,
}) {
  const screens = useBreakpoint();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSectionIndex, setCurrentSectionIndex] = useState(
    activeSection1 ? activeSection1 : iteam[0]
  );
  const { userData } = useAuth();

  // New state to track if the search input is focused
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const [sectionState, setSectionState] = useState(() => {
    const sectionsData = { ...sections?.section };
    Object.keys(sectionsData).forEach((sectionId) => {
      delete sectionsData[sectionId].selectedItems;
    });
    return sectionsData;
  });
  const [activeSection, setActiveSection] = useState(iteam[0]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [medicineName, setMedicineName] = useState("");
  const [showInvestigationModal, setShowInvestigationModal] = useState(false);
  const [InvestigationName, setInvestigationName] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showVaccination, setShowVaccination] = useState(false);

  const sectionKeys = Object.keys(sectionState);
  console.log("Section Keys:", sections);
  useEffect(() => {
    setActiveSection(iteam[0]);
  }, [iteam.length]);

  const searchItem = async (query) => {
    switch (activeSection) {
      case "symptoms": {
        const result = await getsymptom(query, userData.id);
        setFilteredItems(result?.data || []);
        break;
      }
      case "findings": {
        const result = await getFindings(query, userData.id);
        setFilteredItems(result?.data || []);
        break;
      }
      case "diagnosis": {
        const result = await getDiagnoses(query, userData.id);
        setFilteredItems(result?.data || []);
        break;
      }
      case "medicines": {
        const result = await getmedicine(query, userData.id);
        setFilteredItems(result?.data || []);
        break;
      }
      case "investigations": {
        const result = await getInvestigations(query, userData.id);
        setFilteredItems(result?.data || []);
        break;
      }
      case "instructions": {
        const result = await getInstruction(query, userData.id);
        setFilteredItems(result?.data || []);
        break;
      }
      case "procedures": {
        const result = await getProcedure(query, userData.id);
        setFilteredItems(result?.data || []);
        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    console.log("Active Section changed to:", activeSection);
    if (!activeSection) return; // No section selected

    if (searchQuery.length >= 2) {
      console.log("Searching for:", searchQuery, "in section:", activeSection);
      // Fetch from backend
      searchItem(searchQuery);
    } else {
      const filtered = sectionState[activeSection];
      console.log(filtered)
      setFilteredItems(filtered);
    }
  }, [searchQuery, activeSection]);
  //   useEffect(() => {
  //   if (InvestigationName) setShowInvestigationModal(true);
  // }, [InvestigationName]);

  const handleAdd = async (name) => {
    const form = { name };
    console.log(form);
    let result;
    switch (activeSection) {
      case "symptoms": {
        result = await addsymptom(form);
        break;
      }
      case "findings": {
        result = await addFinding(form);
        break;
      }
      case "diagnosis": {
        result = await addDiagnoses(form);
        break;
      }
      case "medicines": {
        setMedicineName(name);

        setShowModal(true);
        break;
      }
      case "investigations": {
        setInvestigationName(name);
        setShowInvestigationModal(true);

        break;
      }
      case "instructions": {
        result = await addInstruction(form);
        break;
      }
      case "procedures": {
        result = await addProcedure(form);
        break;
      }
      default:
        messageApi.error("Something went wrong");
        break;
    }
    console.log("result after add item ", result);
    if (result?.success) {
      messageApi.open({
        type: "success",
        content: `${activeSection} add successfully!`,
      });
      setSearchQuery("");
      setSearchQuery1("");

      const result1 = onItemSelect(activeSection, result?.data);
      setSelectedItems(result1);
    } else {
      result?.error?.name?.forEach((element) => {
        messageApi.error(element || "Something went wrong");
      });
    }
  };
  const handleClose = (data) => {
    console.log("add modal closed ", data);
    if (data != null && data != undefined) {
      const result1 = onItemSelect(activeSection, data);

      setSelectedItems(result1);
      setSearchQuery("");
      setSearchQuery1("");
    }
    setShowModal(false);
    setShowInvestigationModal(false);
    // refresh(prev => !prev);
  };

  const handleEdit = (data) => {
    setEdit(true);
    setEditData(data);
  };

  // Responsive styles

  const searchInputStyle = {
    marginBottom: screens.xs ? 8 : 12,
    width: "100%",
    height: "50px",
    padding: "0 0 0 11px",
  };

  const tagStyle = {
    padding: screens.xs ? "3px 9px" : "15px 15px",
    borderRadius: "30px 30px 30px 30px",
    marginBottom: screens.xs ? 4 : 8,
    marginRight: screens.xs ? 4 : 8,
    fontSize: screens.xs ? "1rem" : "1.2rem",
    maxWidth: "100%",
    whiteSpace: "normal",
    wordBreak: "break-word",
    fontWeight: "bold",
    borderWidth: "2px",
    borderStyle: "solid",
    color: "#474646ff",
    transition: "all 0.3s ease-in-out",
  };

  const selectedTagStyle = {
    ...tagStyle,
    backgroundColor: "#e6f4ff",
    color: "#0958d9",
    borderColor: "#91caff",
  };

  const unselectedTagStyle = {
    ...tagStyle,
    cursor: "pointer",
    ":hover": {
      transform: "scale(1.02)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    WebkitTouchCallout: "none", // Disable long press menu (iPad/iPhone)
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    userSelect: "none",
  };

  const itemsContainerStyle = {
    maxHeight: "calc(100% - 110px)",
    overflowY: "auto",
    overflowX: "hidden",
    // padding: "8px 4px",
  };
  const tabLinkStyle = (key) => ({
    padding: "8px 6px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: screens.xs ? "1rem" : "1.2rem",
    color: activeSection == key ? "#1890ff" : "#555",
    borderBottom:
      activeSection == key ? "3px solid #1890ff" : "3px solid transparent",
    transition: "all 0.2s ease-in-out",
  });

  const currentSectionId = sectionKeys[currentSectionIndex];
  const currentSection = sectionState[currentSectionId];
  const popoverContent = (
    <div
      style={{
        maxWidth: "420px",
        maxHeight: "260px", // ✅ only if >3
        overflowY: "auto", // ✅ scrollbar only then
        paddingRight: "6px", // ✅ for pretty scrollbar spacing
      }}
    >
      <style>
        {`
      .thin-scroll::-webkit-scrollbar {
        width: 4px;        /* ✅ Thin scrollbar */
      }
      .thin-scroll::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }
      .thin-scroll::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
      }
      .thin-scroll::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
      }
    `}
      </style>
      {caseSheetData.map(
        (item, index) =>
          Array.isArray(item[activeSection]) &&
          item[activeSection].length > 0 && (
            <div
              key={index}
              style={{
                marginBottom: "16px",
                paddingBottom: "8px",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              {/* ✅ Date + Copy all */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "15px",
                  fontWeight: 500,
                  marginBottom: "8px",
                }}
              >
                <span>-{dayjs(item?.appointment_date).format("Do MMM")}</span>

                {/* <span
            style={{
              color: "#1677ff",
              fontWeight: 500,
              cursor: "pointer",
            }}
            onClick={(e) => {e.stopPropagation(),handleTagClick(item[activeSection])}}
          >
            Copy all
          </span> */}
              </div>

              {/* ✅ Medicine tags */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                {item[activeSection].map((m, i) => (
                  <Badge
                    key={i}
                    bg="light"
                    text="dark"
                    style={{
                      padding: "8px 14px",
                      borderRadius: "25px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      marginRight: "8px",
                      marginBottom: "8px",
                      cursor: "default",
                    }}
                    onClick={(e) => {
                      e.stopPropagation(), handleTagClick(m);
                    }}
                  >
                    {m.name}
                  </Badge>
                ))}
              </div>
            </div>
          )
      )}
    </div>
  );
  const handleTagClick = (itemObj) => {
    // Check if already selected
    const exists =
      Array.isArray(selectedItems?.[activeSection]) &&
      selectedItems[activeSection].some((s) => s.id === itemObj.id);
    if (!exists) {
      // add to selectedItems

      let reslut = onItemSelect(activeSection, itemObj);
      // optional: if you want to add into input or your section logic
      setSelectedItems(reslut);
    }
  };
  const inputRef = useRef(null);

  useEffect(() => {
    const searchInput = inputRef.current?.input;

    const handleBlur = () => {
      // Small timeout to allow the 'Add' button click to register
      setTimeout(() => {
        setIsSearchFocused(false);
      }, 150);
    };

    const handleViewportResize = () => {
      const vh = window.visualViewport.height;
      const ih = window.innerHeight;

      // FIX: Only trigger "Keyboard Closed" logic if the viewport is back to full height
      // AND the active element is actually our search input.
      // We add a 100ms delay to make sure we aren't catching the start of an opening animation.
      if (vh >= ih - 50) {
        // We use a small delay here to distinguish between "closing" and "just starting to open"
        setTimeout(() => {
          if (window.visualViewport.height >= window.innerHeight - 50) {
            setIsSearchFocused(false);
            if (document.activeElement === searchInput) {
              searchInput.blur();
            }
          }
        }, 100);
      }
    };

    searchInput?.addEventListener('focusout', handleBlur);
    window.visualViewport?.addEventListener('resize', handleViewportResize);

    return () => {
      searchInput?.removeEventListener('focusout', handleBlur);
      window.visualViewport?.removeEventListener('resize', handleViewportResize);
    };
  }, []);



  // const handleSelect = (item) => {
  //   setSelectedPanelId(ionCreateNewtem.id);
  //   if (onSelectPanel) onSelectPanel(item);
  //   setOpen(false); // Close popover upon selection
  // };

  const handleCreateNewClick = async () => {

  };

  const [open, setOpen] = useState(false);
  const [popoverView, setPopoverView] = useState("list"); // 'list' | 'create'
  const [panelName, setPanelName] = useState("");
  const [selectedPanelId, setSelectedPanelId] = useState(null);
  const [panelData, setPanelData] = useState([]);

  useEffect(() => {
    // Only fetch when the popover is actually open and in 'list' view
    if (open && popoverView === "list") {
      fetchInvestigationGroups();
    }
  }, [open, popoverView]);

  const fetchInvestigationGroups = async () => {
    try {

      const result = await getInvestigationGroup(userData?.id);
      if (result.success) {
        console.log(result?.data);
        setPanelData(result?.data)
      } else {
        console.log("result?.data");

      }
    } catch (err) {
      console.log("result?.data");
    }
  };


  // Reset view to 'list' whenever popover opens/closes
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
    if (!newOpen) {
      setPopoverView("list");
      setPanelName("");
    }
  };


  const handleSavePanel = async () => {
    if (!panelName.trim()) return;

    const investigationIds = selectedItems?.investigations?.map(
      (item) => item.id
    ) || [];
    const payload = {
      doctor_id: userData?.id,
      group_name: panelName.trim(),
      investigation_ids: investigationIds,
    };
    try {
      const result = await addInvestigationGroups(payload);
      if (result.success) {
        messageApi.open({
          type: "success",
          content: `group added successfully!`,
        });

      } else {
        messageApi.error(result?.message)
      }
    } catch (err) {
      messageApi.error("somethis went wrong !")
    }

    setPopoverView("list");
    setPanelName("");
  };

  // Content 1: List View
  const listViewContent = (
    <div style={{ width: 280, margin: "0px 0px" }}>
      <div
        onClick={() => setPopoverView("create")}
        style={{
          padding: "10px 16px",
          color: "#1890ff",
          fontWeight: 600,
          cursor: "pointer",
          borderBottom: "1px solid #f0f0f0",
          fontSize: "14px",
        }}
      >
        Create New
      </div>

      <List
        dataSource={panelData}
        renderItem={(item) => (
          <List.Item
            onClick={() => {
        setSelectedPanelId(item.id);

        // Batch add all investigations from the selected panel
        addInvestigationPanel(activeSection, item?.investigations);

        setOpen(false);
      }}
          >
            <div>
              <div style={{ color: "#262626", fontWeight: 600, fontSize: "14px" }}>
                {item?.group_name}
              </div>
              <div
                style={{
                  color: "#8c8c8c",
                  fontSize: "12px",
                  whiteSpace: "nowrap",       // Keeps text on a single line
                  overflow: "hidden",          // Hides overflowing content
                  textOverflow: "ellipsis",    // Adds '...' when text exceeds container width
                  maxWidth: "220px",           // Set max width to trigger truncation
                }}
              >
                {item?.investigations?.map((inv) => inv?.name).join(", ")}
              </div>
            </div>
            {selectedPanelId === item.id && (
              <CheckOutlined style={{ color: "#1890ff", fontWeight: "bold" }} />
            )}
          </List.Item>
        )}
      />
    </div>
  );

  // Content 2: Create Panel Form View
  const createViewContent = (
    <div style={{ width: 260, margin: "-12px -16px" }}>
      <div
        style={{
          padding: "12px 16px",
          textAlign: "center",
          fontWeight: 600,
          fontSize: "14px",
          color: "#262626",
          borderBottom: "1px solid #f0f0f0",
        }}
      >
        Add investigation panel
      </div>

      <div style={{ padding: "16px" }}>
        <Input
          placeholder="Enter Name"
          value={panelName}
          onChange={(e) => setPanelName(e.target.value)}
          autoFocus
          style={{
            backgroundColor: "#f5f5f5",
            borderRadius: "6px",
            height: "40px",
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          borderTop: "1px solid #f0f0f0",
        }}
      >
        <Button
          type="text"
          onClick={() => setPopoverView("list")}
          style={{
            flex: 1,
            height: "44px",
            borderRadius: "0 0 0 8px",
            borderRight: "1px solid #f0f0f0",
            color: "#1890ff",
            fontWeight: 500,
          }}
        >
          Cancel
        </Button>
        <Button
          type="text"
          onClick={handleSavePanel}
          style={{
            flex: 1,
            height: "44px",
            borderRadius: "0 0 8px 0",
            color: "#1890ff",
            fontWeight: 500,
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );





  return (
    <>
      {contextHolder}
      <div
        style={{
          height: "100%",
          flexDirection: "column",

          // padding: screens.xs ? "16px 8px" : "24px 16px",
        }}
      >
        {/* Navigation Controls - Wrapped for smooth hide/shrink */}
        <div
          style={{
            maxHeight: isSearchFocused ? "0" : "60px",
            opacity: isSearchFocused ? "0" : "1",
            overflow: "hidden",
            transition: "max-height 0.3s ease-out, opacity 0.3s ease-out", // Transition applied here
          }}
        >
          <div
            style={{
              // --- MODIFIED STYLE HERE ---
              display: "flex",
              justifyContent: "space-around", // Changed from "flex-start" to distribute tabs equally
              alignItems: "center",
              marginBottom: "12px",
              borderBottom: "1px solid #f0f0f0",
              width: "100%", // Ensure the container spans full width
            }}
          >
            {iteam.map((tab) => (
              <div
                key={tab}
                style={{
                  ...tabLinkStyle(tab),
                  flexGrow: 1,
                  // ⭐ FIX: Make the main tab container a flex row
                  display: "flex",
                  alignItems: "center", // Vertically centers content
                  justifyContent: "center", // Horizontally centers the group (tab name + icon)
                  gap: "8px", // Space between the tab name and the icon/popover
                  textTransform: "capitalize",
                  height: "100%", // Ensures full height for click area
                  cursor: "pointer",
                }}
                onClick={() => {
                  setActiveSection(tab);
                  setSearchQuery("");
                  setSearchQuery1("");
                  setShowSidebar(false);
                }}
              >
                {/* Tab Name */}
                <span style={{ whiteSpace: "nowrap" }}>{tab}</span>

                {/* Popover containing the History Icon */}
                {activeSection == tab &&
                  <Popover
                    content={popoverContent}
                    trigger="click"
                    placement="bottomLeft"
                    overlayStyle={{
                      borderRadius: "10px",
                      padding: "10px",
                    }}
                  >
                    <span
                      // Removed redundant display: "flex" here as the parent handles alignment
                      style={{
                        height: "100%",
                        cursor: "pointer",
                      }}
                      onClick={(e) => e.stopPropagation()} // Stops the popover click from triggering the tab change
                    >
                      <HistoryOutlined
                        style={{ fontSize: "18px", color: "#1677ff" }}
                      />
                    </span>
                  </Popover>
                }
              </div>
            ))}
          </div>
        </div>

        {/* Search Input */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
          <Input
            ref={inputRef}
            placeholder={`Search ${activeSection}...`}
            prefix={
              <SearchOutlined
                style={{
                  color: "#000000ff",
                  fontSize: screens.xs ? "16px" : "25px",
                }}
              />
            }
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setSearchQuery1(e.target.value);
              setShowSidebar(false);
            }}
            onPressEnter={(e) => handleAdd(searchQuery)}
            style={searchInputStyle}
            onFocus={() => setIsSearchFocused(true)}
            suffix={
              searchQuery.length >= 2 && (
                <Button
                  type="primary"
                  size="large"
                  icon={<PlusOutlined />}
                  style={{
                    height: "100%",
                    padding: screens.xs ? "0 10px" : "0 14px",
                    fontSize: screens.xs ? "16px" : "18px",
                    borderRadius: "0 6px 6px 0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAdd(searchQuery);
                  }}
                />
              )
            }
            size="large"
          />

          {/* Show + Panels button when activeSection is investigation */}
          {(activeSection?.toLowerCase() === "investigation" ||
            activeSection?.toLowerCase() === "investigations") && (
              <Popover
                content={popoverView === "list" ? listViewContent : createViewContent}
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                placement="right"
                arrow={{ pointAtCenter: true }}
              >
                <Button
                  type="link"
                  icon={<PlusOutlined />}
                  style={{
                    fontSize: screens?.xs ? "14px" : "16px",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                    height: "50px",
                    padding: "0px 0px 0px 11px",
                    marginBottom: "12px",
                  }}
                >
                  Panels
                </Button>
              </Popover>
            )}
        </div>

        {/* Selected Items - Wrapped for smooth hide/shrink */}
        {sections[activeSection]?.length > 0 &&
          (activeSection != "investigations" &&
            activeSection != "instructions" &&
            activeSection != "procedures" ? (
            <div
              style={{
                marginBottom: 5,
                maxHeight: isSearchFocused ? "0" : "300px", // Use a sufficiently large maxHeight for normal state
                opacity: isSearchFocused ? "0" : "1",
                overflow: "hidden",
                transition: "max-height 0.3s ease-out, opacity 0.3s ease-out", // Transition applied here
              }}
            >
              {/* <Text strong style={{ display: "block", marginBottom: 5 }}>
              Selected Items:
            </Text> */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: screens.xs ? 8 : 12,
                }}
              >
                {/* Selected Items - Wrapped for smooth hide/shrink */}
                {sections[activeSection]?.length > 0 && (
                  <div
                    style={{
                      marginBottom: 5,
                      maxHeight: isSearchFocused ? "0" : "300px", // Use a sufficiently large maxHeight for normal state
                      opacity: isSearchFocused ? "0" : "1",
                      overflow: "hidden",
                      transition:
                        "max-height 0.3s ease-out, opacity 0.3s ease-out", // Transition applied here
                    }}
                  >
                    {/* ... */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: screens.xs ? 8 : 12,
                      }}
                    >
                      {sections[activeSection]?.map((item) => (
                        <Tag
                          key={item.id}
                          style={{
                            ...selectedTagStyle,
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            const result = onItemSelect(activeSection, item);
                            setSelectedItems(result);
                          }}
                        >
                          <span style={{ marginRight: "8px" }}>
                            {item.name}
                          </span>
                          {/* The CloseOutlined icon with its new wrapper for styling */}
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              const result = onIteamRemove(
                                activeSection,
                                item.name
                              );
                              setSelectedItems(result);
                            }}
                            style={{
                              backgroundColor: "#2642b4ff", // Darker green for the close button background
                              borderRadius: "50%", // Makes it circular
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: screens.xs ? "20px" : "30px", // Adjust size as needed
                              height: screens.xs ? "20px" : "30px", // Keep width and height same for circle
                              cursor: "pointer",
                              margin: "-8px -8px -8px 0px",
                              transition: "background 0.3s ease",
                            }}
                          >
                            <CloseOutlined
                              style={{
                                fontSize: screens.xs ? "12px" : "20px",
                                color: "#fff", // White color for the 'x' icon
                              }}
                            />
                          </span>
                        </Tag>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div
              style={{
                marginBottom: 5,
                maxHeight: isSearchFocused ? "0" : "100%",
                opacity: isSearchFocused ? "0" : "1",
                overflow: "hidden",
                transition: "max-height 0.3s ease-out, opacity 0.3s ease-out",
              }}
            >
              <div
                style={{
                  // Changed from flex-wrap to block/column layout
                  display: "block",
                }}
              >
                {sections[activeSection]?.map((item) => (
                  <div key={item.id}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: screens.xs ? "12px 8px" : "16px 12px", // Increased padding for list feel
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        const result = onItemSelect(activeSection, item);
                        console.log(result)
                        setSelectedItems(result);
                      }}
                    >
                      <Text
                        strong
                        style={{
                          fontSize: screens.xs ? "1rem" : "1.1rem",
                          color: "#000",
                          flexGrow: 1,
                        }}
                      >
                        {item.name}
                      </Text>
                      {/* The CloseOutlined icon for removal */}
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          const result = onIteamRemove(
                            activeSection,
                            item.name
                          );
                          setSelectedItems(result);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          marginLeft: "10px",
                        }}
                      >
                        <CloseOutlined
                          style={{
                            fontSize: screens.xs ? "16px" : "20px",
                            color: "#ff4d4f", // Red color for removal action
                          }}
                        />
                      </span>
                    </div>
                    {/* Add Ant Design Divider */}
                    <Divider
                      style={{ margin: "0", borderTop: "1px solid #f0f0f0" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}

        {/* All Items */}
        {activeSection != "investigations" &&
          activeSection != "instructions" &&
          activeSection != "procedures" ? (
          <div style={itemsContainerStyle}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: screens.xs ? 2 : 4,
              }}
            >
              {filteredItems?.map((item) => {
                const isSelected = sections[activeSection]?.some(
                  (selectedItem) => selectedItem?.name === item?.name
                );

                return isSelected ? null : (
                  <Tag
                    key={item?.id}
                    onMouseDown={(e) => {
                      // Start press timer
                      e.stopPropagation();
                      const timer = setTimeout(() => {
                        handleEdit(item); // ← your edit function
                      }, 600); // Hold duration

                      // Save timer ref
                      e.target.pressTimer = timer;
                    }}
                    onMouseUp={(e) => {
                      // If hold didn't complete → treat as normal click
                      clearTimeout(e.target.pressTimer);
                    }}
                    onMouseLeave={(e) => {
                      // Cancel when pointer moves out
                      clearTimeout(e.target.pressTimer);
                    }}
                    onClick={(e) => {
                      if (e.target.longPressTriggered) {
                        e.stopPropagation();
                        e.target.longPressTriggered = false;
                        return;
                      }
                      e.stopPropagation();
                      const result = onItemSelect(activeSection, item);
                      setSelectedItems(result);
                      setShowSidebar(false);
                      setSearchQuery("");
                    }}
                    onTouchStart={(e) => {
                      e.preventDefault(); // Stop iPad text highlight + selection
                      const timer = setTimeout(() => {
                        handleEdit(item);
                      }, 600);
                      e.target.pressTimer = timer;
                    }}
                    onTouchEnd={(e) => {
                      clearTimeout(e.target.pressTimer);
                    }}
                    style={unselectedTagStyle}
                  >
                    {item?.name}
                  </Tag>
                );
              })}
            </div>
          </div>
        ) : (
          <div style={itemsContainerStyle}>
            <div
              style={{
                // Changed from flex-wrap to block/column layout
                display: "block",
              }}
            >
              {filteredItems?.map((item) => {
                const isSelected = sections[activeSection]?.some(
                  (selectedItem) => selectedItem?.name === item?.name
                );

                // Only display unselected items
                return isSelected ? null : (
                  <div key={item?.id}>
                    <div
                      // Add long press and click handlers to the div wrapper
                      onMouseDown={(e) => {
                        // Start press timer
                        e.stopPropagation();
                        const timer = setTimeout(() => {
                          handleEdit(item); // ← your edit function
                        }, 600); // Hold duration

                        // Save timer ref
                        e.target.pressTimer = timer;
                      }}
                      onMouseUp={(e) => {
                        // If hold didn't complete → treat as normal click
                        clearTimeout(e.target.pressTimer);
                      }}
                      onMouseLeave={(e) => {
                        // Cancel when pointer moves out
                        clearTimeout(e.target.pressTimer);
                      }}
                      onClick={(e) => {
                        if (e.target.longPressTriggered) {
                          e.stopPropagation();
                          e.target.longPressTriggered = false;
                          return;
                        }
                        e.stopPropagation();
                        const result = onItemSelect(activeSection, item);
                        console.log(result)
                        setSelectedItems(result);
                        setShowSidebar(false);
                        setSearchQuery("");
                      }}
                      onTouchStart={(e) => {
                        e.preventDefault(); // Stop iPad text highlight + selection
                        const timer = setTimeout(() => {
                          handleEdit(item);
                        }, 600);
                        e.target.pressTimer = timer;
                      }}
                      onTouchEnd={(e) => {
                        clearTimeout(e.target.pressTimer);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: screens.xs ? "12px 8px" : "16px 12px",
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                        // Add a hover effect for better UX
                        ":hover": { backgroundColor: "#807777ff" },
                      }}
                    >
                      <Text
                        style={{
                          fontSize: screens.xs ? "1rem" : "1.1rem",
                          color: "#474646ff",
                        }}
                      >
                        {item?.name}
                      </Text>
                    </div>
                    {/* Add Ant Design Divider */}
                    <Divider
                      style={{ margin: "0", borderTop: "1px solid #f0f0f0" }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      {showModal && (
        <MedicineModal
          show={showModal}
          type="add"
          onHide={handleClose}
          name={medicineName}
        />
      )}
      {showInvestigationModal && (
        <AddModal
          show={showInvestigationModal}
          name_iteam={InvestigationName}
          onHide={handleClose}
          refresh={() => null}
          type="Investigations"
          isedit={false}
        />
      )}
      {activeSection != "medicines" && (
        <AddModal
          show={edit}
          onHide={() => {
            setEdit(false);
          }}
          refresh={refresh}
          type={activeSection}
          isedit={true}
          data={editData}
        />
      )}
      {activeSection == "medicines" && (
        <MedicineForm
          show={edit}
          onHide={() => {
            setEdit(false);
          }}
          refresh={refresh}
          type="edit"
          record={editData}
        />
      )}
    </>
  );
}

SectionManager.propTypes = {
  activeSection1: PropTypes.string,
  sections: PropTypes.object.isRequired,
  onItemSelect: PropTypes.func.isRequired,
  addInvestigationPanel: PropTypes.func.isRequired,
  onIteamRemove: PropTypes.func.isRequired,
  setShowSidebar: PropTypes.func.isRequired,
  autoSave: PropTypes.func,
  setSearchQuery1: PropTypes.func,
  iteam: PropTypes.array,
  refresh: PropTypes.func,
  caseSheetData: PropTypes.array,
};
